import { render, staticRenderFns } from "./HtmlTemplateForm.vue?vue&type=template&id=f0a3ffca&"
import script from "./HtmlTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./HtmlTemplateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f0a3ffca', component.options)
    } else {
      api.reload('f0a3ffca', component.options)
    }
    module.hot.accept("./HtmlTemplateForm.vue?vue&type=template&id=f0a3ffca&", function () {
      api.rerender('f0a3ffca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/HtmlTemplateForm.vue"
export default component.exports